import css from 'styled-jsx/css';

const styles = theme => {
  return css.resolve`
    .capture-button {
      background: ${theme.secondaryColor};
      padding: 10px 20px;
      color: white;
      border: none;
      border-radius: 20px;
      margin-bottom: 10px;
      cursor: pointer;
      position: absolute;
    }
  `;
};

export const global = css.global`
  .video-container video {
    width: 100%;
  }
`;
export default styles;
